﻿export class User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;

    constructor(json: any) {
        this.id = json.id;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.email = json.email;
    }
}
